import type { FormConfig, Form } from '../types/form';


const defaultForm: Form = {
  header: "Zgłoś",
  text: "Zgłoś treść, którą uważasz za nielegalną lub niezgodną z regulaminem.",
  reasonLabel: "Powód zgłoszenia",
  reasonHelper: "Wybór nie jest wiążący",
  explainLabel: "Dlaczego treści są nielegalne lub naruszają regulamin",
  userNameLabel: "Twoje imię i nazwisko lub nazwa",
  userNameOptional: "(opcjonalnie)",
  userMailLabel: "Adres e-mail",
  userMailHelper: "Na ten adres po potwierdzeniu wyślemy informację o sposobie rozpatrzenia zgłoszenia.",
  statuteLabel: "Potwierdzam, że dokonuję zgłoszenia w dobrej wierze, a informacje i zarzuty przedstawione przeze mnie w zgłoszeniu są prawidłowe, zgodne ze stanem faktycznym i kompletne.",
  footer: "Administratorem danych osobowych podanych w formularzu jest Gazeta.pl sp. z o.o. ul. Czerska 8/10, 00-732 Warszawa. Dane osobowe będą przetwarzane w celu załatwienia sprawy opisanej w formularzu i rozpatrzenia zgłoszenia. Dodatkowe informacje o zasadach przetwarzania i ochrony danych osobowych dostępne są w ",
  footerSpan: 'Polityce Transparentności.',
  footerSpanLink: "https://pomoc.gazeta.pl/pomoc/7,192131,30837106,zgody-2.html",
  cancelButton: "Anuluj",
  submitButton: "Zgłoś",
  optional:"(opcjonalnie)",
  btn_cancel: "Anuluj",
  btn_report: "Zgłoś",
  customSelectOptions: [
    { name: "Komercyjny charakter", value: "commercial_nature" },
    { name: "Wulgaryzmy", value: "profanity" },
    { name: "Sprzeczność z dobrymi obyczajami", value: "contradiction_with_good_manners" },
    { name: "Podszywanie się", value: "impersonation" },
    { name: "Dezinformacja", value: "disinformation" },
    { name: "Kopia komentarza", value: "copy_of_comment" },
    { name: "Spam", value: "spam" },
    { name: "Naruszenie dóbr osobistych", value: "infringement_of_personal_rights" },
    { name: "Pomówienie lub znieważenie", value: "slander_or_insult" },
    { name: "Groźby", value: "threats" },
    { name: "Mowa nienawiści", value: "hate_speech" },
    { name: "Naruszenie praw autorskich", value: "copyright_infringement" },
    { name: "Nawoływanie lub pochwalanie przestępstwa", value: "incitement_or_praise_for_crime" },
    { name: "Propagowanie totalitaryzmu", value: "promoting_totalitarianism" },
    { name: "Uporczywe nękanie/stalking", value: "persistent_stalking" },
    { name: "Inne naruszenie", value: "others" },
  ],
  commentTarget: "commentId",
  testingUrl: 'dsaWidget=true&owner=lzawislak&feature=dsa_widget&awdBranch=test',
  mobileCloseButton: false
};

export const allForms:FormConfig = {
  gazeta_pl: defaultForm,
  wyborcza: {
    ...defaultForm,
    footer: 'Administratorem danych osobowych podanych w formularzu jest Wyborcza Sp. z o. o. z siedzibą w Warszawie, ul. Czerska 8/10 (00-732). Dane osobowe będą przetwarzane w celu załatwienia sprawy opisanej w formularzu i rozpatrzenia zgłoszenia. Dodatkowe informacje o zasadach przetwarzania i ochrony danych osobowych dostępne są w naszej ',
    footerSpan: 'Polityce prywatności.',
    footerSpanLink: 'https://wyborcza.pl/centrumpomocygw/7,134956,23413995,polityka-prywatnosci.html',
    commentTarget: "opinion",
    testingUrl: 'dist=vibe-121',
    mobileCloseButton: true
  },
  forum: {
    ...defaultForm,
    commentTarget: '',
    testingUrl: 'branch=feature/VIBE-411'
  },
  sport: defaultForm,
};